import type { AppContextState } from './types';

export const initialState: AppContextState = {
  origin: '',
  host: '',
  platform: 'desktop',
  browser: 'other',
  browserVersion: null,
  osVersion: null,
  isInApp: false,
};
